import React from "react";

import { CardLabel } from "@src/components/card_label";
import { JointVentureCheckbox } from "@src/features/role_request_details/components/joint_venture_checkbox";
import { RootState, useAppSelector } from "@src/setupStore";
import { RoleRequest } from "@src/types/role_request_types";
import { Card, Row, Flex } from "antd";
import "./role_request_information_card.less";
import dayjs from "dayjs";

interface RequestInformationCardProps {
  request: RoleRequest;
}

const RoleRequestInformationCard: React.FC<RequestInformationCardProps> = ({
  request,
}) => {
  const dateTooltip = "Date Format: DD/MM/YYYY";

  // States
  const { isJointVentureProject, jointVenturePartner } = useAppSelector(
    (state: RootState) => state.resourcePlanSlice
  );

  return (
    <Card title="Request" className="role-request-information-card info-card">
      <Row justify="space-between">
        <Flex vertical gap={16}>
          <CardLabel label="Request sent" toolTip={dateTooltip}>
            {request ? dayjs(request.requestSentDate).format("DD/MM/YYYY") : ""}
          </CardLabel>

          {request.jointVenture ? (
            <CardLabel label={"Sent to"}>{jointVenturePartner}</CardLabel>
          ) : (
            <CardLabel label={"Initially sent to"}>
              {request?.teamLead?.fullName}
            </CardLabel>
          )}

          {request?.forwardedTo && (
            <CardLabel label="Forwarded to">
              {request?.forwardedTo?.fullName}
            </CardLabel>
          )}

          {isJointVentureProject && <JointVentureCheckbox request={request} />}
        </Flex>
      </Row>
    </Card>
  );
};

export default RoleRequestInformationCard;
